import { Dialog } from '@material-ui/core';

import React, { FunctionComponent } from 'react';

import Tabla, { Column } from '@infotrack/presentacion-componentes/tabla';
import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import TablaDetallesCargaInventario from './TablaDetallesCargaInventario';
import IBodega from 'Infotrack@Modelos/smartStock/bodegas/entidades/bodega';

interface ITablaDocumentoCargaMasivaProps {
    detalles: IDocumento[];
    cerrarTabla: () => any;
    abrirTabla: boolean;
    consultarDetallesDocumentos: (documentoId: string) => Promise<IDocumentoDetalleConsultaGeneral[]>,
    bodegas: IBodega[]
}

const TablaDocumentoCargaMasiva: FunctionComponent<ITablaDocumentoCargaMasivaProps> = ({
    detalles,
    cerrarTabla,
    abrirTabla,
    consultarDetallesDocumentos,
    bodegas
}) => {
    const obtenerColumnas = () => {
        const columnas: Array<Column<IDocumento>> = [];

        columnas.push({
            field: 'CodigoDocumento',
            title: <Texto id="Documentos.CampoCodigoDocumento.Nombre" />,
        });

        columnas.push({
            field: 'DocumentoRelacionado',
            title: <Texto id="Documentos.CampoDocumentoRelacionado.Nombre" />,
        });

        columnas.push({
            render: (rowData) =>
                bodegas.length > 0 ? bodegas.filter(x => x.BodegaId === rowData.BodegaDestino)[0].BodegaDescripcion : "",
            title: <Texto id="Documentos.CampoBodegaDestino.Nombre" />,
        });
        return columnas;
    };

    return (
        <Dialog open={abrirTabla} maxWidth="xl" fullWidth scroll="body">

            <ModalEncabezado
                cerrar={() => cerrarTabla()}
                titulo={<Texto id="Documentos.Carga" />}
            />

            <Tabla
                detailPanel={
                    (rowData) => {
                        return (
                            <div style={{ padding: '0px', maxHeight: '400px', overflowY: 'auto' }} id={`detalle-panel-${rowData.DocumentoDetalleId}`}>
                                <p>{rowData.description}</p>
                                <TablaDetallesCargaInventario
                                    titulo={<Texto
                                        align="center"
                                        color="inherit"
                                        id={'TablaDetallesPlantilla.DocumentosDertalles'}
                                    />}
                                    documentoId={rowData.DocumentoId}
                                    consultarDetallesDocumento={consultarDetallesDocumentos}
                                />
                            </div>
                        );
                    }


                }
                columns={obtenerColumnas()}
                data={detalles}
                options={{ padding: 'dense', columnsButton: true, }}
            />

        </Dialog>
    );
};

export default TablaDocumentoCargaMasiva;
